<div class="long-time-loader non-blocking" [hidden]="!creatingReport">
  <div class="status-text">
    <div class="spinner-border" role="status"></div>
    <div class="info-text">
      <b> {{ 'text.generatingReport' | transloco }} </b>
      {{ 'text.generatingReportInProgress' | transloco: { name: docName } }}
    </div>
  </div>
</div>
